import { AutocompleteInput } from "@/components/admin";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { UserCheck } from "lucide-react";
import {
  DateInput,
  DateTimeInput,
  Edit,
  NumberInput,
  ReferenceInput,
  SelectInput,
  SimpleForm,
} from "../common";
import { StatusSelectInput } from "../../documents/shared/StatusSelectInput";

const statusChoices = [
  { id: "present", name: "Present" },
  { id: "absent", name: "Absent" },
  { id: "half_day", name: "Half Day" },
  { id: "leave", name: "Leave" },
  { id: "holiday", name: "Holiday" },
  { id: "weekoff", name: "Weekoff" },
];

const sourceChoices = [
  { id: "manual", name: "Manual" },
  { id: "biometric", name: "Biometric" },
  { id: "web", name: "Web" },
  { id: "auto", name: "Auto" },
];

const validateCheckOut = (value: unknown, allValues: Record<string, unknown>) => {
  if (!value || !allValues.check_in) return undefined;
  if (new Date(value as string) <= new Date(allValues.check_in as string)) {
    return "Check-out must be after check-in";
  }
  return undefined;
};

export const AttendanceEdit = () => (
  <Edit title="Edit Attendance" actions={false}>
    <SimpleForm className="max-w-3xl mx-auto space-y-6">
      <Card className="w-full shadow-sm">
        <CardHeader className="pb-3 border-b bg-muted/50">
          <div className="flex items-center gap-2">
            <UserCheck className="w-5 h-5 text-muted-foreground" />
            <CardTitle className="text-lg font-semibold tracking-tight">Edit Attendance Record</CardTitle>
          </div>
        </CardHeader>
        <CardContent className="pt-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <ReferenceInput source="employee_id" reference="employees">
              <AutocompleteInput label="Employee" optionText="name" />
            </ReferenceInput>
            <DateInput source="date" />
            <StatusSelectInput source="status" choices={statusChoices} />
            <SelectInput source="source" choices={sourceChoices} />
            <DateTimeInput source="check_in" />
            <DateTimeInput source="check_out" validate={validateCheckOut} />
            <NumberInput source="hours_worked" label="Hours Worked" />
          </div>
        </CardContent>
      </Card>
    </SimpleForm>
  </Edit>
);
